<div class="disposuite-header">
  <div class="container-fluid window-max-width px-4">
    <div class="row">
      <div class="col-6">
        <div class="mt-2 d-flex align-items-center h-40">
          <a routerLink="/" class="mt-auto mb-auto">
            <img src="{{imagePath}}DispoSuite_logo@3x.svg" alt="DispoSuite" width="145px" height="26px"/>
          </a>
        </div>
      </div>
      <div class="col-6">
        <div class="justify-content-end align-items-center mt-2 d-flex">
          <div class="mt-1 mr-2">
            @if (user?.picture) {
              <img alt="" src="{{user?.picture}}" [title]="user?.name" width="30px" class="rounded-circle" (click)="toggleSettingsMenu(mobileSideMenu)"/>
            } @else {
              <span class="icon28 se-icon-user_standard" (click)="toggleSettingsMenu(mobileSideMenu)"></span>
            }
          </div>
          <app-mobile-side-menu #mobileSideMenu>
            <div class="mobile-side-menu-settings d-sm-none d-flex flex-column top-0 h-100 white-bg">
              <div class="flex-1-1-0 px-3 py-2">
                @if (isLoggedIn) {
                  <a class="settingsMenu d-block  cursor-pointer font-weight-bold w-100 font-size-12 color-black mb-1"  [href]="userProfileUrl" target="_blank" rel="opener"
                  i18n="@@app.my_profile">My Profile</a>
                }
                @if (isLoggedIn) {
                  <a class="settingsMenu d-block cursor-pointer font-weight-bold w-100 font-size-12 color-black mb-1" (click)="onOpenSettings()"
                  i18n="@@app.settings">Settings</a>
                }
                @if (!isLoggedIn) {
                  <a class="settingsMenu d-block cursor-pointer font-weight-bold w-100 font-size-12 color-black mb-1" href="#" (click)="onLogin()" i18n="@@app.login">Login</a>
                }
                @if (isLoggedIn) {
                  <a class="settingsMenu d-block cursor-pointer font-weight-bold w-100 font-size-12 color-black mb-1" href="#" (click)="onLogout()" i18n="@@app.logout">Logout</a>
                }
              </div>
              <div class="w-100 d-flex justify-content-between px-3 py-2" role="group" aria-label="Language selector">
                @for (locale of availableLanguages; track locale) {
                  <button
                    type="button"
                    class="btn-language color-black p-0 font-weight-semibold font-size-12"
                    [ngClass]="{ 'activeLanguage' : selectedLanguage === locale }"
                    (click)="onChangeLanguage(locale)">
                    {{ locale | uppercase }}
                  </button>
                }
              </div>
            </div>
          </app-mobile-side-menu>
          @if (user) {
            <div class="mt-1 px-0 btn-group d-sm-flex d-none" role="group">
              <div class="dropdown">
                <button appClickOutside class="btn dropdown-btn font-weight-bold d-flex align-items-center" type="button" (clickOutside)="clickOutsideOfUserDropdown()"
                  (click)="toggleUserDropdown()"
                  [attr.aria-expanded]="isUserDropdownOpen">
                  {{ user?.name }}
                  <i class="icon24 se-icon float-right">{{isUserDropdownOpen ? 'arrow2_up' : 'arrow2_down'}}</i>
                </button>
                @if (isUserDropdownOpen) {
                  <div class="dropdown-menu show mt-2" aria-labelledby="dropdownMenuButton">
                    @if (isLoggedIn) {
                      <a class="dropdown-item" [href]="userProfileUrl" target="_blank" rel="opener"
                      i18n="@@app.my_profile">My Profile</a>
                    }
                    @if (isLoggedIn) {
                      <a class="dropdown-item cursor-pointer" (click)="onOpenSettings()"
                      i18n="@@app.settings">Settings</a>
                    }
                    @if (!isLoggedIn) {
                      <a class="dropdown-item" href="#" (click)="onLogin()" i18n="@@app.login">Login</a>
                    }
                    @if (isLoggedIn) {
                      <a class="dropdown-item" href="#" (click)="onLogout()" i18n="@@app.logout">Logout</a>
                    }
                  </div>
                }
              </div>
            </div>
          }
          <div class="float-right mt-1">
            <button class="language float-right rounded-circle bg-white d-sm-none font-size-12 p-0"
              (click)="toggleSettingsMenu(mobileSideMenu)">
              {{ selectedLanguage }}
            </button>
            <div appClickOutside class="position-relative mt-1 d-sm-flex d-none" (clickOutside)="clickOutsideOfLanguageDropdown()">
              <button type="button"
                      class="DropDown DropDown2 d-flex align-items-center justify-content-between bg-white fixed-width-52 fixed-height-31 round-button mr-0"
                      (click)="toggleLanguageDropdown()">
                <div class="language-text flex-shrink-0">
                  {{ selectedLanguage }}
                </div>
                <div class="d-flex justify-content-end flex-shrink-0">
                  <i class="icon28 se-icon text-color-brand mx-0">{{languageDropdownOpen ? 'arrow2_up' : 'arrow2_down'}}</i>
                </div>
              </button>
              <div class="custom-dropdown position-absolute z-index-1000 bg-white fixed-width-52"
                   [ngClass]="languageDropdownOpen ? 'd-block' : 'd-none'">
                @for (locale of availableLanguages; track locale) {
                  <button class="dropdown-item text-center text-color-brand font-size-s"
                          [ngClass]="{'active' : selectedLanguage === locale }"
                          (click)="selectedLanguage=locale; onChangeLanguage(locale)">
                  {{ locale }}
                  </button>
                }
              </div>
            </div>
          </div>
          <img alt="Schneider" class="float-right mt-2 ml-3 hidden-sm" width="95px" src="{{imagePath}}schneider.svg"/>
        </div>
      </div>
    </div>
  </div>
</div>
